module.exports = __webpack_public_path__ + "static/media/background1.4e20d340.jpg";